import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DATE_TIME_FORMAT, freePlanExtendPopType } from '@app/_helpers';
import { NotificationsService } from '../../../../providers/notifications/notifications.service';
import { NotificationType } from '../../notifications.consts';
import { FreePlanExtendComponent } from '@app/_shared/modules/free-plan-extend/free-plan-extend.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PLANS_DIALOG_TITLE } from '@app/_shared/strings';
import { MbPlansComponent } from '@app/modules/trading/modules/mb-plans/mb-plans.component';
import { ConfigurationService } from '@app/_shared/providers/configuration/configuration.service';
@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss']
})
export class NotificationCardComponent implements OnInit {

  @Input('type') notificationType;
  @Input('showPlanExtendedOffer') showPlanExtendedOffer;
  @Input('free_plan_extension_days') free_plan_extension_days;
  @Input('showDiyUpdateNotification') showDiyUpdateNotification;
  DATE_TIME_FORMAT = DATE_TIME_FORMAT;
  NotificationType = NotificationType;
  hidePlans: boolean = false;

  constructor(
    public notificationsService: NotificationsService,
    private configService: ConfigurationService,
    private router: Router,
    private dialog: MatDialog,
  ) { }
  ngOnInit(): void { }

  // Route to saved page
  routeTo(val: any) {
    if (val) {
      this.router.navigateByUrl(val);
    }
  }

  openExtendPlan() {
    const data = {
      freePlanExtendType: freePlanExtendPopType.Initial,
      free_plan_extension_days: this.free_plan_extension_days
    }
    this.dialog.open(FreePlanExtendComponent, {
      panelClass: ['extend-free-plan-dialog'],
      width: '340px',
      disableClose: true,
      data
    })
  }

  openPricingDialog() {
    this.dialog.open(MbPlansComponent, {
      panelClass: ['dialog-no-padding-rounded'],
      data: {
        title: PLANS_DIALOG_TITLE
      },
      width: '90%'
    })
  }
}
